import React from 'react'
import {connect} from 'react-redux'
import {TweenMax} from 'gsap'
import NavLink from '../router/NavLink'
import MultiLangText from '../multilang/MultiLangText'
import AnimatedTextBlock from '../text/AnimatedTextBlock'

import ScrollArrow from '../scrollarrow/ScrollArrow'

import AboutSection from './AboutSection'

import MetaTags from 'react-meta-tags'




class AboutPage extends React.Component {



  constructor(){
    super()

    this.state = {

    }

    this.scrollSpy = this.scrollSpy.bind(this)
  }



  scrollSpy(){


  }


  componentDidMount(){
    this.scrollSpy();
  }

  render(){

    let aboutContent = this.props.pagesData.data.filter((item)=>{
      return (item.slug==='about')
    })[0].acf.about_content

    let acf = this.props.pagesData.data.filter((item)=>{
      return (item.slug==='about')
    })[0].acf

    //console.log('aboutContent',aboutContent);



    return (<div className="about-page scroll-anchor">
              <div className="content-rows">
                  {
                    aboutContent.map((item,index)=>{

                                return <AboutSection key={'s'+index} item={item} index={index} aboutContent={aboutContent} />
                    })
                  }
                  </div>
                  <MetaTags>
                    <meta name="description" content={(acf.meta_description)? acf.meta_description : ''} />
                  </MetaTags>
              </div>)
  }

}


const mapStateToProps = (state)=>{
  let pagesData = state.KastnerStore.pagesData

  return {
      pagesData
    }
}

export default connect(mapStateToProps)(AboutPage);



// WEBPACK FOOTER //
// ./src/modules/pages/AboutPage.js